// extracted by mini-css-extract-plugin
export default {"row":"NumerationScreen_row__N+MJE","alignCenter":"NumerationScreen_alignCenter__Be7b6"};